import { Component } from '@angular/core';
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from '../header/header.component';
import { MatCardModule } from '@angular/material/card';
import { CruscottoRichiestaService } from '../cruscotto-richiesta/cruscotto-richiesta.service';
import { Stato } from '../types/Stato';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { NgFor, NgIf } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { CruscottoStatisticheService } from './cruscotto-statistiche.service';
import { CruscottoStatistiche, RichiestePerStato } from '../types/CruscottoStatistiche';
import { concatMap } from 'rxjs';

@Component({
    selector: 'app-cruscotto-statistiche',
    imports: [HeaderComponent, FooterComponent, MatCardModule, MatDividerModule, MatListModule, MatChipsModule, MatIcon, NgIf],
    templateUrl: './cruscotto-statistiche.component.html',
    styleUrl: './cruscotto-statistiche.component.css'
})
export class CruscottoStatisticheComponent {

  caricamento = true;
  stati: Stato[] = [];
  statistiche = new CruscottoStatistiche();

  constructor(
    private richiesteService: CruscottoRichiestaService,
    private cruscottoStatisticheService: CruscottoStatisticheService
  ) { }

  ngOnInit() {
    this.getStati().then(() => {
      this.getStatistiche();
    }).catch((e) => {
      console.error(e);
    })
  }

  getStatistiche() {

    this.cruscottoStatisticheService.getRichiesteTotali()
      .pipe(
        concatMap((totaleRichieste: number) => {
          this.statistiche.totaleRichieste = totaleRichieste;
          return this.cruscottoStatisticheService.getPazientiTotali();
        }),
        concatMap((totalePazienti: number) => {
          this.statistiche.totalePazienti = totalePazienti;
          return this.cruscottoStatisticheService.getPazientiMaschiTotali();
        }),
        concatMap((totalePazientiMaschi: number) => {
          this.statistiche.totalePazientiMaschi = totalePazientiMaschi;
          return this.cruscottoStatisticheService.getPazientiFemmineTotali();
        }),
        concatMap((totalePazientiFemmine: number) => {
          this.statistiche.totalePazientiFemmine = totalePazientiFemmine;
          return this.cruscottoStatisticheService.getTotaleRichiestePerStato();
        })
      )
      .subscribe({
        next: (richiestePerStato: RichiestePerStato[]) => {
          this.statistiche.richiestePerStato = richiestePerStato;
          this.caricamento = false;
        },
        error: (error) => {
          console.error(error);
        }
      });

  }

  getStati() {
    return new Promise<void>((resolve, reject) => {
      this.richiesteService.getStati()
        .subscribe({
          next: (stati: Stato[]) => {
            this.stati = stati;
            resolve();
          },
          error: (error) => {
            console.error(error);
            reject(error);
          }
        });
    })
  }

  numeroRichiestePerStato(stato: Stato): number {
    let richStato = this.statistiche.richiestePerStato.find(r => r.codice === stato.codice);
    return richStato?.numeroRichieste || 0;
  }

}
